import Page from 'components/layout/Page';
import { useI18n } from 'hooks/useI18n';
import { Trans } from 'next-i18next';
import { useState } from 'react';
import { scroller } from 'react-scroll';
import Faqs from '../shared/Faqs';
import { FaqProps } from '../shared/FaqsItem';
import ResistanceHero from './ResistanceHero';
import { StyledResistanceLanding } from './ResistanceLandingComponent.styled';

const ResistanceLandingComponent: React.FC = () => {
  const { t } = useI18n('resistanceLanding');

  const [activeFaq1, setActiveFaq1] = useState(false);
  const [activeFaq6, setActiveFaq6] = useState(false);

  const onRiskClick = (e: React.MouseEvent<HTMLAnchorElement>): void => {
    e.preventDefault();
    setActiveFaq1(true);

    setTimeout(() => {
      scroller.scrollTo('faq1', {});
    }, 250);
  };

  const onRewardsClick = (e: React.MouseEvent<HTMLAnchorElement>): void => {
    e.preventDefault();
    setActiveFaq6(true);

    setTimeout(() => {
      scroller.scrollTo('faq6', {});
    }, 250);
  };

  const glossary: FaqProps[] = [
    {
      question: t('faqs.q1'),
      active: activeFaq1,
      answer: (
        <Trans
          ns="resistanceLanding"
          i18nKey={'faqs.a1'}
          components={{
            ul: <ul />,
            li: <li />,
            infojobs: (
              <a
                href="https://developer.infojobs.net/legal/legal/terms-of-use.xhtml"
                target="_blank"
                rel="noreferrer"
              />
            ),
            linkedin: (
              <a
                href="https://www.linkedin.com/legal/user-agreement"
                target="_blank"
                rel="noreferrer"
              />
            ),
            indeed: (
              <a
                href="https://www.indeed.com/legal"
                target="_blank"
                rel="noreferrer"
              />
            ),
            xing: (
              <a
                href="https://dev.xing.com/api/terms_and_conditions"
                target="_blank"
                rel="noreferrer"
              />
            )
          }}
        />
      ),
      renderComponent: true,
      anchor: 'faq1'
    },
    {
      question: t('faqs.q2'),
      answer: t('faqs.a2')
    },
    {
      question: t('faqs.q3'),
      answer: t('faqs.a3')
    },
    {
      question: t('faqs.q4'),
      answer: t('faqs.a4')
    },
    {
      question: t('faqs.q5'),
      answer: t('faqs.a5')
    },
    {
      question: t('faqs.q6'),
      answer: t('faqs.a6'),
      anchor: 'faq6',
      active: activeFaq6
    },
    {
      question: t('faqs.q7'),
      answer: (
        <Trans
          ns="resistanceLanding"
          i18nKey={'faqs.a7'}
          components={{
            mail: (
              <a href="mailto:support@getmanfred.com">support@getmanfred.com</a>
            )
          }}
        />
      )
    }
  ];

  return (
    <Page hasScrollTop pageVariant="dark">
      <StyledResistanceLanding>
        <ResistanceHero
          onRiskClick={onRiskClick}
          onRewardsClick={onRewardsClick}
        />

        <Faqs faqs={glossary} title={t('faqs.title')} />
      </StyledResistanceLanding>
    </Page>
  );
};

export default ResistanceLandingComponent;
